import React, { Component } from 'react'

export class AppFormData extends Component {
    
    filterVisible([name, value], j) {
        let { fields = [] } = this.props;
        let getField = (name) => (fields.find(o => o.name == name));
        return [undefined,true].includes(getField(name)['data-visible']);
    }

    render() {
        let { props } = this;
        let { data = {}, size = 1, fields = [], submitText = "SUBMIT", fieldclass = "", slots = {} } = props;
        let ndata = fields.reduce((o, n) => ({ ...o, [n.name]: (data[n.name] ?? n.defaultValue) || "" }), {});
        let list = Object.entries(ndata).chunk(size);
        let getField = (name) => (fields.find(o => o.name == name));
        let formAttrs = Object.except(props, ['data', 'fields', 'size', 'submitText', 'slots']);
        return (
            <AppForm {...formAttrs} >
                {
                    list.map((row, i) => (
                        <Row className="mx-0" key={i}>
                            {
                                row
                                .filter((...args)=>this.filterVisible(...args))
                                .map(([name, value], j) => (
                                    <Col key={j+'-'+name} className={fieldclass}>
                                        <AppInput
                                            name={name}
                                            label={name.toTitleCase()}
                                            defaultValue={value}
                                            {...getField(name)}
                                        >
                                        </AppInput>
                                    </Col>
                                ))
                            }
                        </Row>
                    ))
                }
                {slots.below && <div>
                    <slots.below />
                </div>}
                <Row>
                    <Col className="text-right">
                        <button className='btn add-btn'>
                            {submitText}
                        </button>
                    </Col>
                </Row>
            </AppForm>
        )
    }
}

export default AppFormData